import { Controller, RegisterOptions, useFormContext } from "react-hook-form";
import AsyncSelectCreatable from "../select/AsyncSelectCreatable";
import { GroupBase, OptionsOrGroups } from "react-select";
import { SelectItem, SelectNewOption } from "../select/Select";
import AsyncSelect from "../select/AsyncSelect";
import { ReactNode } from "react";

interface AutocompleteSelectInputProps {
  name: string;
  placeholder?: string;
  required?: boolean;
  className?: string;
  options?: RegisterOptions;
  loadOptions: (
    inputValue: string,
    callback: (
      options: OptionsOrGroups<SelectItem, GroupBase<SelectItem>>,
    ) => void,
  ) => void;
  disableCreatable?: boolean;
  newOption?: SelectNewOption;
  customOnSelect?: (value: SelectItem | SelectItem[] | null) => void;
  menuListFooter?: ReactNode;
  noOptionsText?: string;
  enableDefaultOptions?: boolean;
}

const AutocompleteSelectInput = ({
  name,
  className,
  options,
  placeholder,
  required,
  loadOptions,
  disableCreatable,
  newOption,
  customOnSelect,
  menuListFooter,
  noOptionsText,
  enableDefaultOptions,
}: AutocompleteSelectInputProps) => {
  const { control, getFieldState, formState } = useFormContext();

  const { invalid, isDirty, error } = getFieldState(name, formState);

  return (
    <div className="mb-2">
      <Controller
        name={name}
        control={control}
        rules={options}
        render={({ field }) =>
          disableCreatable ? (
            <AsyncSelect
              {...field}
              loadOptions={loadOptions}
              invalid={invalid}
              placeholder={placeholder}
              onChange={(value) => {
                field.onChange(value);
                customOnSelect?.(value);
              }}
              newOption={newOption}
              menuListFooter={menuListFooter}
              noOptionsText={noOptionsText}
              enableDefaultOptions={enableDefaultOptions}
            />
          ) : (
            <AsyncSelectCreatable
              {...field}
              loadOptions={loadOptions}
              invalid={invalid}
              placeholder={placeholder}
              onChange={(value) => {
                field.onChange(value);
                customOnSelect?.(value);
              }}
              newOption={newOption}
              menuListFooter={menuListFooter}
              noOptionsText={noOptionsText}
              enableDefaultOptions={enableDefaultOptions}
            />
          )
        }
      />
      {error && isDirty && (
        <div className="text-error mt-1 text-[13px]">{error.message}</div>
      )}
    </div>
  );
};

export default AutocompleteSelectInput;
